import React from 'react';
import classnames from 'classnames';
import {observer} from 'mobx-react';
import m from 'moment';
import styles from './DayGraphView.css';

import EventView from './EventView';

function DayGraphView({store, day, person}) {
  const faulty = day.faulty;
  const dateText = `${m(day.time).format('LL')}${day.autoLunch ? '*' : ''}`;

  const createGraph = () => {
    const graphs = [];
    let activeTime = day.time;

    // add the events
    day.events.forEach((event, i) => {
      const styleName = event.event === 'in' ? styles.out : styles.in;
      const width = (event.time - activeTime) / 86400000 * 100;
      activeTime = event.time;
      graphs.push(
        <div key={i} className={styleName} style={{width: `${width}%`}} />
      )
    });

    // add end of day to the end
    // if the day has not ended yet....
    if (day.events.length > 0) {
      if (m(day.time).isSame(m(), 'day')) {
        const endWidth = (Date.now() - day.events[day.events.length - 1].time) / 86400000 * 100;
        graphs.push(
          <div key="end" className={styles[day.events[day.events.length - 1].event]} style={{width: `${endWidth}%`}}/>
        );
      } else {
        const endWidth = (m(day.time).endOf('day') - day.events[day.events.length - 1].time) / 86400000 * 100;
        graphs.push(
          <div key="end" className={styles.out} style={{width: `${endWidth}%`}}/>
        );
      }
    }

    return graphs;
  };

  const createDivider = () => {
    const parts = [];
    for (let i = 0; i < 24; i++) {
      parts.push(<div key={i}/>)
    }
    return parts;
  };

  const createDetails = () => {
    return (
      <div>
        {person.eventsByStint(day.events).map(stint => {
          return (
            <div className={styles.stint} key={stint.in.id || stint.out.id}>
              <EventView event={stint.in} store={store}/>
              <EventView event={stint.out} store={store}/>
              <div>{store.convertToHours(stint.length)}</div>
            </div>
          )
        })}
      </div>
    )
  };


  const handleViewClick = () => {
    day.toggleOpen();
  };

    console.log({day});
  return (
    <div className={styles.container}>
      <div
        className={styles.wrapper}
        onClick={handleViewClick}
      >
        <div className={classnames(styles.dateWrapper, faulty ? styles.faulty : null)}>
          <p className={styles.dateText}>{dateText}</p>
          <p className={styles.timeText}>{store.convertToHours(day.totalWorkTime)}</p>
        </div>
        <div className={classnames(
          styles.graphWrapper,
          faulty ? styles.blurred : false
        )
        }>
          <div className={styles.graph}>
            {createGraph()}
          </div>
          <div className={styles.ruler}>
            {createDivider()}
          </div>
        </div>
      </div>
      {day.open ? createDetails() : null}
    </div>
  )
}

export default observer(DayGraphView);


// WEBPACK FOOTER //
// ./src/views/Beeper/Components/DayGraphView.js